import { useBooleanFlag } from '@trm/feature-flags/web';

export const useTraderProfileModerationFlag = () => ({
  isTraderProfileModerationEnabled: useBooleanFlag('trader-profile-moderation', false),
});
